<!-- http://localhost:4201/#/error?errid=102 http://localhost:4201/#/error?errid=101 -->
<div class="not-found">
  <div class="img-class">
    <img
      class="site-logo"
      src="assets/images/logos/Logo_2020.png"
      style="height: 25px"
    />
  </div>
  <div class="login-container">
    <div class="login-container-left">
      <ngx-slick-carousel
        (init)="slickInit($event)"
        (beforeChange)="beforeChange($event)"
        (afterChange)="setNewFeature($event)"
        class="user-carousel"
        id="login-carousel"
        #slickModal="slick-carousel"
        [config]="slideConfig"
      >
        <div ngxSlickItem *ngFor="let slide of userdata" class="leftcontain">
          <div class="leftcontain-image">
            <img
              [src]="
                coresService.getImageURL(
                  slide.ImageUrl,
                  '../../../../assets/images/Goal1.png',
                  false
                )
              "
              alt=""
            />
          </div>
          <div class="leftcontain-text">
            <div class="pluse" *ngIf="slide.IsNewFeature">
              <a
                [routerLink]="[]"
                class="no-border"
                (click)="openSite(SiteUrl)"
              >
                {{ 'Employee.PulseSurvey' | translate }}
              </a>
            </div>
            {{ slide.Text }}
          </div>
          <div class="certificate_new" *ngIf="slide.IsNewFeature">
            <span class="fa-layers fa-fw">
              <a
                [routerLink]="[]"
                class="no-border"
                (click)="openSite(SiteUrl)"
              >
                <i class="fas fa-5x fa-certificate"></i>
                <span
                  class="fa-layers-text fa-inverse"
                  data-fa-transform="shrink-11.5"
                >
                  {{ 'Employee.New' | translate }}
                </span>
              </a>
            </span>
          </div>
        </div>
      </ngx-slick-carousel>
    </div>
    <div
      class="login-container-right display-flex-column div-part-2"
      style="background-color: var(--white)"
    >
      <div
        class="middle-box loginscreen animated fadeInDown"
        style="min-height: 70vh"
      >
        <div style="position: relative">
          <h3 class="welcometext logo-title">
            {{ 'Messages.WelcomePatPat' | translate }}
          </h3>
          <p class="text-contain">{{ Message | translate }}</p>
          <button
            *ngIf="count == 102"
            type="button"
            (click)="backtoLogin()"
            style="margin-top: 15px"
            class="btn btnSubmit btn-default block full-width m-b"
          >
            {{ 'Employee.BackToLogin' | translate }}
          </button>
          <div class="separator">
            <div class="or-line"></div>
            <div class="or-text">{{ 'Employee.or' | translate }}</div>
            <div class="or-line"></div>
          </div>
          <div class="not-found-last-text">
            {{ 'Employee.Further_Support' | translate }}
            <a href="mailto:support@patpat360.com?subject=Support%20Required">
              <span>{{ 'Employee.contactUs' | translate }}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="terms-condition">
        <div class="bottomLast">
          <div class="display-flex-center bottomLast-footer button-link">
            <a
              href="https://www.iubenda.com/terms-and-conditions/89240152"
              class="login-forgot"
            >
              {{ 'Employee.TermsConditions' | translate }}
            </a>
          </div>
          <div class="display-flex-center bottomLast-footer button-link">
            <a
              href="https://www.iubenda.com/privacy-policy/89240152"
              class="login-forgot"
            >
              {{ 'Employee.Privacy' | translate }}
            </a>
          </div>
        </div>
        <div class="text-center">
          <p class="copyright">
            <a href="https://www.patpat360.com" target="_blank">
              {{ 'Employee.Poweredby' | translate }}
              {{ 'Employee.Peopleyield' | translate }} &copy; {{ coopyright }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="error-template">
        <h1>
          Oops!</h1>
       
        <div class="error-details"  [innerHTML]="Message | translate">
     
        </div>
         <div class="error-actions" style="display: none;">
          <a (click)="onAdmin()" href="javascript:void(0)" class="btn btn-default btn-lg">
            <span class="glyphicon glyphicon-home"></span>
            {{'Generic.ContactYourAdmin' | translate}} </a>
         
        </div> 

        <div class="error-actions">
  
          <a  href="mailto:support@patpat360.com?subject=Support%20Required" class="btn btn-default btn-lg">
            <span class="glyphicon glyphicon-envelope" ></span>
            {{'Generic.ContactPatPat' | translate}} </a>
         
        </div>
      </div>
    </div>
  </div>
</div> -->
